const CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

/**
 *
 * @return {String}
 */
function getRandomChar() {
  return CHARS[Math.floor(Math.random() * CHARS.length)]
}

/**
 *
 * @param {Number} length
 *
 * @return {String}
 */
export default function generateId(length = 16) {
  return (new Array(length)).fill().map(() => getRandomChar()).join('')
}